import { InfiniteData, useInfiniteQuery } from '@tanstack/react-query';
import {
  GetOracleActivitiesResponse,
  OracleEventCounts
} from '@blisspointmedia/bpm-types/dist/OracleApi';
import { useOracleCidScope } from './useOracleCidScope';
import { oracleFeedQueryOptions } from './useOracleEventsData';

const UNAVAILABLE_PROVENANCE = 'unavailable';

// Module-level so `select` keeps one identity and TanStack can reuse its last result.
// The BFF's placeholder (all -1, empty bands) reads as "no counts",
// so consumers render it the same way they render counts that are still loading.
const selectFirstPageCounts = (
  data: InfiniteData<GetOracleActivitiesResponse>
): OracleEventCounts | undefined => {
  const counts = data.pages[0]?.counts;
  return counts?.bands.provenance === UNAVAILABLE_PROVENANCE ? undefined : counts;
};

// Page 0 only, so loading more pages never re-renders a consumer.
// Read only `.data`:
// touching any other field of the query result subscribes the caller to its changes too.
export const useOracleEventCounts = (): OracleEventCounts | undefined => {
  const scope = useOracleCidScope();
  return useInfiniteQuery({ ...oracleFeedQueryOptions(scope), select: selectFirstPageCounts }).data;
};
